/** @jsx jsx */

import { Colors, Grid, Margin, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import DateToNowWithTooltip from 'app/developer-v3/components/DateToNowWithTooltip';
import InfoCount from 'app/developer-v3/components/InfoCount';
import Link from 'app/common/components/Link';
import withTrackInteraction, {
  WithPartnerUserInteractionTrackerProps,
} from 'app/developer-v3/teams/team-partner-sharing/withPartnerUserInteractionTracker';

import TagGroup from '../TagGroup';
import IssueTag, { IssueStatus, IssueTagType } from '../IssueTag';

import type { IssueItem as IssueItemType } from 'app/developer-v3/hooks';

interface Props extends WithPartnerUserInteractionTrackerProps {
  issue: IssueItemType;
  route: string;
}

const Styles = {
  issue: css`
    border: 1px solid ${Colors.GrayWarm4};
    border-radius: 10px;
    margin-bottom: 20px;
    padding: 15px 25px;
    &:hover {
      background-color: ${Colors.GrayWarm3};
    }
  `,
  root: css`
    text-decoration: none;
  `,
};

const IssueItem = ({ handleTrackInteraction, issue, route }: Props) => {
  const {
    commentsCount,
    createdAt,
    isBlocking,
    status,
    statusDisplay,
    title,
    typeOfDisplay,
  } = issue;

  const isMarkedResolved = status === 3;

  return (
    <Link
      css={Styles.root}
      href={route}
      onClick={() =>
        handleTrackInteraction({
          eventAction: 'click',
          interactionGoal: 'Views a specific bug or feature',
          interactionName: 'detail_view_bugs_features',
        })
      }
    >
      <section aria-label="Issue Item" css={Styles.issue}>
        <Grid alignItems="center" columns="auto 1fr 30px" gap={15}>
          <TagGroup>
            {isBlocking && <IssueTag type={IssueStatus.Blocking} />}
            {typeOfDisplay && <IssueTag type={typeOfDisplay} />}
            {isMarkedResolved && (
              <IssueTag type={statusDisplay as IssueTagType} />
            )}
          </TagGroup>
          <Text>
            {'Open for '}
            <DateToNowWithTooltip date={new Date(createdAt)} />
          </Text>
          <InfoCount count={commentsCount} icon="commentBlankFill" />
        </Grid>
        <Margin margin="20px 0px 0px 0px">
          <Text>{title}</Text>
        </Margin>
      </section>
    </Link>
  );
};

export default withTrackInteraction(IssueItem);
